import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=6ae13a6f&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae13a6f')) {
      api.createRecord('6ae13a6f', component.options)
    } else {
      api.reload('6ae13a6f', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=6ae13a6f&", function () {
      api.rerender('6ae13a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Jtg3pW3u5L6q/JS/comp/ImgFallback2.vue"
export default component.exports